<section class="action-bar" [class.no--link]="!actionBar.url">
  @if (actionBar.routerLink?.length) {
    <a class="action-bar__inner block-link" [routerLink]="actionBar.routerLink">
      <span [ngClass]="actionBar.shortText ? 'd-lg-none' : 'd-none'">{{ actionBar.shortText }}</span>
      <span [ngClass]="actionBar.shortText ? 'd-none d-lg-inline' : ''">{{ actionBar.text }}</span>
    </a>
  }
  @if (!actionBar.routerLink?.length && actionBar.url) {
    <a class="action-bar__inner block-link" [href]="actionBar.url">
      <span [ngClass]="actionBar.shortText ? 'd-lg-none' : 'd-none'">{{ actionBar.shortText }}</span>
      <span [ngClass]="actionBar.shortText ? 'd-none d-lg-inline' : ''">{{ actionBar.text }}</span>
    </a>
  }

  @if (!actionBar.url) {
    <div class="action-bar__inner">
      <span [ngClass]="actionBar.shortText ? 'd-lg-none' : 'd-none'">{{ actionBar.shortText }}</span>
      <span [ngClass]="actionBar.shortText ? 'd-none d-lg-inline' : ''">{{ actionBar.text }}</span>
    </div>
  }
</section>
